document.addEventListener('DOMContentLoaded', ()=>{
	if(window.innerWidth <= 1000){
      let div_to_marquee = document.querySelector('.custom_tagChangerMARQUEE');
        let html_of_element = div_to_marquee.innerHTML;
          div_to_marquee.innerHTML = "";
            const marquee_tag = document.createElement('marquee');
            marquee_tag.setAttribute('class', 'custom__marquee');
          marquee_tag.setAttribute('scrollAmount', '4');
        marquee_tag.innerHTML = html_of_element;
      div_to_marquee.appendChild(marquee_tag)      
        console.log('rendered!')
	} else {
        console.log('not rendered!')
    }
})